module.exports = __webpack_public_path__ + "img/process3.fd44031f.png";